import { Component, OnInit } from '@angular/core';
import { Booking } from '../booking';
import { BookingService } from '../service/booking.service';
import { HttpService } from '../service/http.service';
import { Vademecum } from '../vademecum';
import { SchoolInfo } from '../school-info';

@Component({
  selector: 'app-edit-school-info',
  templateUrl: './edit-school-info.component.html',
  styleUrls: ['./edit-school-info.component.css']
})
export class EditSchoolInfoComponent implements OnInit {

  booking!: Booking;
  vademecum!: Vademecum;
  schoolDoc!: SchoolInfo;

  constructor(
    private bookingService: BookingService,
    private httpService: HttpService
  ) { }

  ngOnInit() {
    this.booking = this.bookingService.booking;
    if(this.booking){
      this.httpService.getVademecumByBookingId(this.booking.id!)
      .subscribe(vademecum => {
        this.vademecum = vademecum;
        
        console.log(this.schoolDoc);
      });
    }
  }

}
